import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// IC FunFlow — pill badges with uppercase, tracked-out labels.
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-0.5 text-[11px] font-bold uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-secondary/15 text-secondary",
        secondary:
          "border-transparent bg-primary/10 text-primary",
        accent:
          "border-transparent bg-accent/20 text-[#92400E]",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow",
        success:
          "border-transparent bg-emerald-50 text-emerald-700",
        outline: "text-foreground border-slate-200 bg-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
